/**
 * ClockWidget — Horloge premium avec gradient adaptatif
 */
import React, { memo, useState, useEffect, useMemo } from 'react';

const DAYS   = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
const MONTHS = ['jan', 'fév', 'mar', 'avr', 'mai', 'jun', 'jul', 'aoû', 'sep', 'oct', 'nov', 'déc'];

const PERIODS = [
  { from: 0,  to: 5,  icon: '🌙', accent: 'rgba(99,102,241,0.20)'  },
  { from: 5,  to: 8,  icon: '🌅', accent: 'rgba(217,119,6,0.20)'   },
  { from: 8,  to: 12, icon: '☀️', accent: 'rgba(234,88,12,0.18)'   },
  { from: 12, to: 14, icon: '🍽️', accent: 'rgba(234,179,8,0.18)'   },
  { from: 14, to: 18, icon: '💼', accent: 'rgba(14,165,233,0.18)'  },
  { from: 18, to: 21, icon: '🌆', accent: 'rgba(139,92,246,0.20)'  },
  { from: 21, to: 24, icon: '🌙', accent: 'rgba(99,102,241,0.20)'  },
];

function getPeriod(h) {
  return PERIODS.find(p => h >= p.from && h < p.to) || PERIODS[0];
}

export const ClockWidget = memo(function ClockWidget({ isSyncing }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 10000);
    return () => clearInterval(id);
  }, []);

  const hh     = String(now.getHours()).padStart(2, '0');
  const mm     = String(now.getMinutes()).padStart(2, '0');
  const period = getPeriod(now.getHours());
  const day    = DAYS[now.getDay()];
  const date   = `${now.getDate()} ${MONTHS[now.getMonth()]}`;

  return (
    <div
      className="flex-1 flex flex-col justify-between px-3.5 py-3 rounded-2xl border border-white/[0.06] relative overflow-hidden"
      style={{
        background: `linear-gradient(150deg, ${period.accent} 0%, rgba(10,10,16,1) 70%)`,
        minWidth: 0,
      }}
      role="time"
    >
      {/* Période */}
      <div className="flex items-center justify-between">
        <span className="text-base leading-none">{period.icon}</span>
        {isSyncing && (
          <div className="w-1.5 h-1.5 rounded-full bg-blue-400/60 animate-pulse" />
        )}
      </div>

      {/* Heure */}
      <div className="my-1">
        <span className="font-mono font-bold leading-none tracking-tight"
          style={{ fontSize: 'clamp(28px, 8vw, 36px)', color: 'rgba(240,240,252,0.92)' }}>
          {hh}<span style={{ color: 'rgba(255,255,255,0.18)' }}>:</span>{mm}
        </span>
      </div>

      {/* Date */}
      <p className="text-xs leading-none" style={{ color: 'rgba(255,255,255,0.30)' }}>
        {day} {date}
      </p>
    </div>
  );
});

export default ClockWidget;
